module.exports = __webpack_public_path__ + "media/images/icon_originals-61dce1adaa299c959f5249f645831fcf.png";